import { useContext } from "react";
import { AgencyAccountLinkingContext } from "../agencyAccountLinking/agencyAccountLinkingContext";

const useAgencyAccountLinking = () => useContext(AgencyAccountLinkingContext);

export default useAgencyAccountLinking;
